import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {
    path: '/',
    component: () => import('@/views/home/index'),
    children: [
      {
        path: '',
        redirect: '/index'
      },

      {
        path: 'buy',
        name: 'buy',
        component: () => import('@/views/home/buy'),
      },
      {
        path: 'cart',
        name: 'cart',
        component: () => import('@/views/home/cart'),
      },
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/home/order'),
      },
    ]
  },
  {
    path: '/orders',
    name: 'orders',
    component: () => import('@/views/home/order'),
  },
  {
    path: '/niudanji',
    name: 'niudanji',
    component: () => import('@/views/home/niudanji'),
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('@/views/index/index'),
  },
  { path: '/404', component: () => import('@/views/404'), hidden: true },

]

export const asyncRouterMap = [
  { path: '*', redirect: '/404', hidden: true }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js